export const viewerZIndices = {
  webGlRenderer: 0,
  css3dRenderer: 1,
  cssLabels: 2,
  menu: 4,
  toolbar: 4,
  shareSkyViewDialog: 4,
};
